var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3566 1.60093C15.222 -0.533644 11.7488 -0.533644 9.6141 1.60093C8.72902 2.48602 8.18674 3.60995 8.04589 4.85124C7.926 5.90772 8.11912 6.9844 8.59161 7.92813L0.0427246 16.4771L2.48051 18.9148L3.47353 17.9218L4.55173 19L6.8655 16.6862L5.7873 15.608L6.58067 14.8147L7.65887 15.8929L9.97265 13.5791L8.89445 12.5009L11.0294 10.3659C11.9732 10.8384 13.0498 11.0316 14.1063 10.9116C15.3476 10.7708 16.4715 10.2285 17.3566 9.34343C19.4912 7.20885 19.4912 3.73555 17.3566 1.60093ZM16.5693 8.55611C15.1422 9.98324 12.9429 10.2483 11.2212 9.20056L10.8474 8.97315L7.31974 12.5009L8.39794 13.5791L7.65887 14.3182L6.58067 13.24L4.21255 15.608L5.29076 16.6862L4.55173 17.4253L3.47353 16.3471L2.48051 17.3401L1.61747 16.4771L9.98441 8.11012L9.757 7.73639C8.70931 6.01462 8.97436 3.81542 10.4015 2.38829C12.1019 0.687864 14.8688 0.687864 16.5693 2.38829C18.2697 4.08879 18.2697 6.85565 16.5693 8.55611Z",
    fill: "#0E142C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2533 3.1246C12.5422 3.83569 12.5422 4.99272 13.2533 5.70388C13.6089 6.05938 14.0759 6.23717 14.5429 6.23717C15.0099 6.23717 15.477 6.05938 15.8325 5.70384H15.8326C16.5436 4.99272 16.5436 3.83569 15.8325 3.1246C15.1214 2.41352 13.9644 2.41356 13.2533 3.1246ZM15.0452 4.91648C14.7682 5.19349 14.3176 5.19341 14.0407 4.91648C13.7637 4.63952 13.7637 4.18889 14.0407 3.912C14.1792 3.77351 14.361 3.70425 14.5429 3.70425C14.7248 3.70425 14.9068 3.77348 15.0452 3.91196C15.3221 4.18892 15.3221 4.63952 15.0452 4.91648Z",
    fill: "#0E142C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIco);
export default __webpack_public_path__ + "static/media/users-ico.8e3db98bb9df4e37a2fa4bf654d88810.svg";
export { ForwardRef as ReactComponent };